import { inject } from 'aurelia-framework';
import { Router } from 'aurelia-router';
import { TestimonialCaptureAPI } from '../../services/testimonialCaptureAPI';
import { EnvironmentService } from '../../services/environmentService';


@inject(Router, EnvironmentService)
export class BrandVideoStart {
    constructor(router, envService) {
        this.router = router;
        this.envService = envService;


        this.validateName = false;
        this.validateEmail = false;
        this.savingUserInfo = false;
        this.branded_video_verbiage = "Simply name your video and you'll be ready to record.";
        this.home_url_new = window.location.origin;
        this.home_url = window.home_url;
        this.terms = window.location.origin;
        this.urlOrigin = this.terms.toLowerCase().includes("magnfi") ? true : false;

        this.policy_url = this.urlOrigin? this.home_url + '/privacy-policy' : this.terms + '#/capture/policy';
        this.term_url = this.urlOrigin ? this.home_url + '/terms-of-service' : this.terms + '#/capture/termsOfService';
        // this.capture_bottom_img = "images/capture_bottom.png";
        this.capture_bottom_img = "images/magnfi-logo-small.png";
        this.is_whitelabel = false;
        if(window.whitelabel) {
            this.capture_bottom_img = "api/whitelabel/getFile?file=capture_bottom";
             this.is_whitelabel = true;
        }

    }


    activate(model, route) {



        if (model.method)
            this.method = model.method;

        if(model.uploadonly && model.uploadonly == 1)
            this.uploadOnly = true

        this.capture_key = model.key;

        if(route.settings && route.settings.captureType)
            this.captureType = route.settings.captureType;
        else
            this.captureType = 0;

        if(this.captureType == 2) {
            this.maxRecordTime = 95;
        } else {
            this.maxRecordTime = 55;
        }


        this.api = new TestimonialCaptureAPI(this.captureType);

    }

    attached() {
        if (this.capture_key) {

        this.api.getByCaptureKey(this.capture_key, this.saveLoadSuccess.bind(this), this.saveLoadError.bind(this));
        this.api.getVerbiage(this.capture_key, this.saveLoadSuccess1.bind(this), this.saveLoadError.bind(this));

        }

    }

    saveLoadSuccess(org_name, website, mlink_return_url, chrome_min_ver) {
        this.setData(org_name, mlink_return_url, chrome_min_ver);

        this.checkSupported();


    }
    saveLoadSuccess1(data ) {
       console.log('$$$$$$$$$$$$$$$$$ hey', JSON.stringify(data));
       console.log('Simple Collection Link : ',data.verbiage.branded_video_verbiage);
        var branded_video_verbiage = data.verbiage.branded_video_verbiage;

        if(this.is_whitelabel) {
            this.branded_video_verbiage = (!branded_video_verbiage) ? this.branded_video_verbiage : branded_video_verbiage;
        }
       //console.log('$$$$$$$$$$$$$$$$$ hey', JSON.stringify(data));
       //console.log('Simple Collection Link : ',data.verbiage.simple_collection_verbiage);
        var branded_video_verbiage = data.verbiage.branded_video_verbiage;
        //this.simple_collection_verbiage = 'Leave a Video Review for';

        if(branded_video_verbiage !== null && branded_video_verbiage !== ''){
            this.is_default_verbiage = false;
            this.branded_video_verbiage = branded_video_verbiage;
            console.log('Default verbiage is false ... showing custom verbiage');
        } else {
            this.is_default_verbiage = true;
            console.log('Default verbiage is true ... showing default verbiage')
        }
    }

    saveLoadError(msg) {

        if(msg == "invalid key")
            this.router.navigate("/");


    }

    setData(org_name, mlink_return_url, chrome_min_ver) {


        this.org_name = org_name;
        this.chrome_min_ver = chrome_min_ver;

    }

    checkSupported() {
        if (this.envService.isMobile()) {

            var supportedChrome = false;

            if(this.envService.isChrome()){
                supportedChrome = true;

                if(this.chrome_min_ver) {
                    var version = this.envService.getBrowserVersion();

                    supportedChrome = parseInt(this.chrome_min_ver) <= version;
                }
            }

            if (this.envService.isAndroid() && !supportedChrome && !this.uploadOnly) {
                if(this.envService.isChrome())
                    this.router.navigate("#/capture/unsupported");
                else
                    this.router.navigate("#/capture/unsupported?url=brand/" + this.capture_key);

            }
        }
    }



    submitBrandVideoInfo() {
        if(this.validateBrandVideoInfo()) {
            this.savingUserInfo = true;
            this.api.createVideo(
                {
                    video_name: this.video_name,
                    capture_key: this.capture_key
                },
                this.createVideoCallback.bind(this),
                this.saveLoadError.bind(this));
        }
    }

    createVideoCallback(video_id) {
        console.log(video_id);
        sessionStorage['magnfi_captureKey'] = this.capture_key;

        var querystring = "";

        if(this.uploadOnly)
            querystring += "uploadonly=1";

        if(this.method) {
            if(querystring)
                querystring += "&";
            querystring += "method=" + this.method;
        }

        this.router.navigate('video/brand/' + video_id + (querystring ? '?' + querystring : '') );

    }

    validateBrandVideoInfo() {
        var pass = true;
        this.validateVideoName = false;

        if (this.video_name == null || this.video_name.trim() == '') {
            this.validateVideoName = true;
            pass = false;
        }

        return pass;
    }

}
